import { ReactElement, ReactNode } from 'react';

import { ExpandMore } from '@mui/icons-material';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary, { getAccordionSummaryUtilityClass } from '@mui/material/AccordionSummary';

export interface IAccordionProps extends AccordionProps {
  title?: string;
  expandIcon?: ReactElement;
  titleAdornment?: ReactNode;
}

function Accordion({ title, titleAdornment, children, expandIcon = <ExpandMore />, ...props }: IAccordionProps) {
  return (
    <MuiAccordion {...props}>
      <AccordionSummary
        expandIcon={expandIcon}
        sx={(theme) => ({
          backgroundColor: theme.palette.primary.light,
          flexDirection: 'row-reverse',

          [`>.${getAccordionSummaryUtilityClass('content')}`]: {
            alignItems: 'center',
            justifyContent: 'space-between',
          },

          [`&.${getAccordionSummaryUtilityClass('expanded')}`]: {
            backgroundColor: theme.palette.background.paper,
          },

          [`>.${getAccordionSummaryUtilityClass('expandIconWrapper')}`]: {
            color: theme.palette.primary.main,
            mr: 2,
          },
        })}
      >
        {title}
        {titleAdornment}
      </AccordionSummary>
      <AccordionDetails sx={{ pTop: 2 }}>{children}</AccordionDetails>
    </MuiAccordion>
  );
}

export default Accordion;
